import React from 'react';
 
const Location  = () => {
        return (
            <iframe title="Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3612.015008298653!2d29.293637908192064!3d40.90524020152196!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cadbb4a29596a3%3A0x304a3b0e01f6d05!2sBirgiMefar!5e0!3m2!1str!2str!4v1667888979191!5m2!1str!2str" loading="lazy" referrerpolicy="no-referrer-when-downgrade" width="100%" height="450" frameborder="1" allowfullscreen="true" style={{position:'relative',border:'none'}} sandbox></iframe> 
        );
}

export default Location